(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplatesViewModel', CampaignTemplatesViewModelFactory);

  /** @ngInject */
  function CampaignTemplatesViewModelFactory(campaignTemplateActions, gridUtils, dialogsService, $translate, CampaignTemplateItemViewModel) {
    function CampaignTemplatesViewModel() {
      this.currentPage = 1;
      this.orderBy = 'name';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_CAMPAIGN_TEMPLATE_ERROR');

      init.call(this);
    }

    CampaignTemplatesViewModel.prototype.destroy = function () {
      this.data.forEach(function (itemViewModel) {
        itemViewModel.destroy();
      });
    };

    CampaignTemplatesViewModel.prototype.deleteSelected = function () {
      var that = this;
      dialogsService.showConfirmDialog('CONFIRM_DELETE_CAMPAIGN_TEMPLATE', 'CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT', 'DELETE')
        .then(function () {
          campaignTemplateActions.deleteCampaignTemplate(that.selected[0].id).then(function () {
            refresh.call(that);
          }, function () {
            that.hasErrorMessage = true;
          });
        });
    };

    return CampaignTemplatesViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.pagerLabel = gridSettings.translations;

      refresh.call(this);
    }

    function refresh() {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;
      this.hasErrorMessage = false;
      campaignTemplateActions.getCampaignTemplates().then(function (jsonArray) {
        if (jsonArray && jsonArray.length > 0) {
          that.count = jsonArray.length;
          jsonArray.forEach(function (json) {
            this.push(new CampaignTemplateItemViewModel(json));
          }, that.data);
        }
      });
    }
  }
})();
